import clsx from 'clsx'
import React from 'react'
import { IoIosClose } from 'react-icons/io'
import { IconBaseProps } from 'react-icons/lib'

interface FormErrorProps {
    error: string
}

export const FormError: React.FC<FormErrorProps> = ({ error }) => {
    return error ? (
        <span className='text-red-500 text-sm h-4'>
            {error}
        </span>
    )
        : null
}

export const FormDescription: React.FC<{ description: string, required?: boolean }> = ({ description, required }) => {
    return (
        <p className='text-sm font-medium mb-2'>{description} {required && <span>*</span>}</p>
    );
}

export const FormLabel: React.FC<{ label: string; required?: boolean }> = ({ label, required = false }) => {
    return (
        <label className="text-xs font-medium relative top-2 ml-[7px] mb-0 px-[3px] w-fit">
            {label} {required && <span>*</span>}
        </label>
    );
}

interface CancelButtonProps extends IconBaseProps {
    className?: string
}

export const CancelButton: React.FC<CancelButtonProps> = (props) => {
    const { className, ...restOfProps } = props

    return (
        <IoIosClose
            size={32}
            className={clsx(
                "cursor-pointer hover:opacity-50",
                className
            )}
            {...restOfProps}
        />
    )
}